<style scoped lang="scss">
.Withdrawal-content-div {
    height: 100vh;
    background-color: rgb(242 242 242) !important;
}


//移动端
@media screen and (max-width: 768px) {
    .Withdrawal_data-div {
        min-width: fit-content;
        margin-left: 1rem;
        width: fit-content;
        background-color: white;
        padding: 1rem;
        padding-top: 30px;
        margin-top: 1rem;
    }

    .Withdrawal-content-div {
        min-width: fit-content;
    }
}
// pc端
@media screen and (min-width: 768px) {
    .Withdrawal_data-div {
        padding-top: 30px;
        max-width: 95%;
        margin-left: 3rem;
        width: fit-content;
        background-color: white;
        padding-bottom: 1.5rem;
        margin-top: 1.5rem;
        
    .liu-text-success {
        color: #10b981;
        font-weight: 500;
        font-size: 0.95rem;
        letter-spacing: 0.01em;
        position: relative;
        padding-left: 1.25rem;

        &::before {
            content: '\2705';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .liu-text-danger {
        color: #ef4444;
        font-weight: 500;
        font-size: 0.95rem;
        letter-spacing: 0.01em;
        position: relative;
        padding-left: 1.25rem;

        &::before {
            content: '\274C';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    }

    .Withdrawal_data {
        max-width: 100%;
    }
}

.pagination {
    margin: 1.5rem auto 0;
    width: fit-content;
}

.Withdrawal_data {
    width: 90vw;
    height: 80vh;
    overflow: auto;
}

.Withdrawal-header {
    font-weight: 550;
    cursor: pointer;
}

.pagination {
    margin: 1.5rem auto 0;
    width: fit-content;
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;height: 100vh;overflow: auto;padding-left: 0;background-color: rgb(242, 242, 242) !important;">
                    <div class="Withdrawal-content-div">
                        <div style="margin-bottom: 3rem;">
                            <div class="Withdrawal_data-div rounded shadow">
                                <el-table :data="Withdrawal_data" class="Withdrawal_data">
                                    <el-table-column prop="id" label="id" />
                                    <el-table-column prop="uid" label="用户" />
                                    <el-table-column prop="money" label="提现金额">
                                        <template #default="scope">
                                            <div  :class="{ 'liu-text-success': scope.row.state == 1, 'liu-text-danger': scope.row.state == -1 }">
                                                {{ scope.row.money }}元
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column style="z-index: 9999;" prop="skm" label="收款码">
                                        <template v-slot="scope">
                                            <div style="z-index: 9999;" class="demo-image__preview">
                                                <el-image :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
                                                    :src="scope.row.skm"
                                                    style="width: 100px; height: 100px;z-index: 9999;" />
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="act" label="提现方式">
                                        <template v-slot="scope">
                                            <div v-if="scope.row.act == 'wx'">微信</div>
                                            <div v-else-if="scope.row.act == 'zfb'">支付宝</div>
                                            <div v-else>未知</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="remarks" label="备注">
                                    </el-table-column>
                                    <el-table-column prop="state" label="状态">
                                        <template v-slot="scope">
                                            <div
                                                :class="{ 'liu-text-waring': scope.row.state == 0, 'liu-text-success': scope.row.state == 1, 'liu-text-danger': scope.row.state == -1 }">
                                                {{ getWithdrawalAct(scope.row.state) }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="res_code" label="处理结果">
                                        <template v-slot="scope">
                                            <div v-if="!isNull(scope.row.res_code)">{{ scope.row.res_code }}</div>
                                            <div v-else>无</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="add_time" label="申请时间" />
                                    <el-table-column prop="end_time" label="处理时间">
                                        <template v-slot="scope">
                                            <div v-if="!isNull(scope.row.end_time)">{{ scope.row.end_time }}</div>
                                            <div v-else>无</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template v-slot="scope">
                                            <div v-if="scope.row.state == 0">
                                                <el-button type="primary" style="width: 5rem;margin:0 ;"
                                                    @click="updateWithdrawalFun1(1, scope.row.id)">已打款</el-button>
                                                <el-button type="danger"
                                                    style="width: 5rem;margin:0 ;margin-top: 0.5rem;"
                                                    @click="updateWithdrawalFun1(-1, scope.row.id)">驳回</el-button>
                                            </div>
                                            <div class="liu-text-success" v-else>已完结</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination class="pagination" v-model:current-page="Withdrawal_Conf.currentPage"
                                    v-model:page-size="Withdrawal_Conf.pageSize" :page-sizes="[10, 25, 50]"
                                    layout="total, sizes, prev, pager, next, jumper" :total="Withdrawal_Conf.total"
                                    @size-change="WithdrawalSizeChange" @current-change="WithdrawalCurrentChange" />

                            </div>
                        </div>
                        <el-dialog v-model="withdrawalDialog.Visible" label-width="auto" title="" width="500">
                            <el-form style="padding: 2rem;" :model="form" label-position="top">
                                <el-form-item label="处理结果">
                                    <el-input type="textarea" rows="5" v-model="withdrawalDialog.form.res_code"
                                        autocomplete="off" />
                                </el-form-item>
                            </el-form>
                            <template #footer>
                                <div class="dialog-footer">
                                    <el-button @click="withdrawalDialog.Visible = false">Cancel</el-button>
                                    <el-button type="primary" @click="updateWithdrawal()">
                                        确定
                                    </el-button>
                                </div>
                            </template>
                        </el-dialog>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isNull } from "@/utils/publicMethods"
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            Withdrawal_Conf: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            Withdrawal_data: [],
            withdrawalDialog: {
                Visible: false,
                form: {
                    res_code: "",
                    id: "",
                    state: "",
                }
            }
        }
    },
    methods: {
        getWithdrawalAct(act) {
            //    1:收入，2：支出，3：登录，4，其他
            switch (act) {
                case -1:
                    return "提现驳回"
                case 0:
                    return "等待审核"
                case 1:
                    return "已打款"
                default:
                    return "未知"
            }
        },
        getUserWithdrawal() {
            openLoading()
            const data = new FormData();
            data.append("page", this.Withdrawal_Conf.currentPage)
            data.append("pageSize", this.Withdrawal_Conf.pageSize)
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/adminApi/getUserWithdrawal', data, { timeout: 5000, headers })
                .then(res => {
                    // isLogin(res)
                    if (res.data.code == 0) {
                        this.Withdrawal_data = res.data.data
                        this.Withdrawal_Conf.total = res.data.total ? res.data.total : 10
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        WithdrawalSizeChange(val) {
            this.Withdrawal_Conf.pageSize = val
            this.getUserWithdrawal()
        },
        WithdrawalCurrentChange(val) {
            this.Withdrawal_Conf.currentPage = val
            this.getUserWithdrawal()
        },
        isNull(text) {
            return isNull(text);
        },
        updateWithdrawalFun1(state, id) {
            this.withdrawalDialog.form.state = state
            this.withdrawalDialog.form.id = id
            if (state == 1) {
                this.withdrawalDialog.form.res_code = "管理员已为您打款，请及时查收，若有问题请及时联系管理员"
                this.withdrawalDialog.Visible = true
            } else if (state == -1) {
                this.withdrawalDialog.form.res_code = "由于此订单存在异常，管理员已拒绝打款，请及时联系管理员进行处理"
                this.withdrawalDialog.Visible = true
            }
        },
        updateWithdrawal() {
            let act = this.withdrawalDialog.form.state
            let id = this.withdrawalDialog.form.id
            let value = this.withdrawalDialog.form.res_code
            openLoading()
            const data = new FormData();
            data.append("state", act)
            data.append("id", id)
            data.append("res_code", value)
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/adminApi/setWithdrawalStatus', data, { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 0) {
                        ElMessage.success(res.data.msg)
                        this.getUserWithdrawal()
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                    this.withdrawalDialog.Visible = false
                })
        }
    },
    mounted() {
        this.getUserWithdrawal()
    }
})
</script>
